import React from 'react'
import { Link } from 'react-router-dom'

const CredibilitySection = () => {
  return (
    <section className="sb-about-text sb-p-90-90">
      <div className="sb-bg-1">
        <div />
      </div>
      <div className="container">
        <div className="text-center sb-mb-60">
          <h2 className="sb-mb-30">Our Commitment to <span style={{color:"#d1a965"}}>Transparency</span></h2>
          <p className="sb-text" style={{maxWidth: 700, margin: "0 auto"}}>
            At Sky Bar, we take pride in sourcing our beverages from trusted, reputable vendors. 
            We believe in being fully transparent with our customers — from the bottles we 
            purchase to how we responsibly dispose of them after every use.
          </p>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="sb-features-item sb-mb-60">
              <div className="sb-number">
                <i className="fas fa-wine-bottle" style={{fontSize: 42, color: "#d1a965"}}></i>
              </div>
              <div className="sb-feature-text">
                <h3 className="sb-mb-15">Bottle Breaking Gallery</h3>
                <p className="sb-text sb-mb-30">
                  After every bottle is served and enjoyed by our guests, we responsibly break 
                  and dispose of it. Watch our collection of bottle breaking videos to see our 
                  dedication to transparency and authenticity.
                </p>
                <Link to="/bottle-gallery" className="sb-btn sb-btn-2 sb-btn-gray">
                  <span className="sb-icon">
                    <img src="img/ui/icons/arrow-2.svg" alt="icon" />
                  </span>
                  <span>Watch Videos</span>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="sb-features-item sb-mb-60">
              <div className="sb-number">
                <i className="fas fa-receipt" style={{fontSize: 42, color: "#d1a965"}}></i>
              </div>
              <div className="sb-feature-text">
                <h3 className="sb-mb-15">Purchase Receipts</h3>
                <p className="sb-text sb-mb-30">
                  Every drink we serve can be traced back to a legitimate purchase. We share 
                  our vendor receipts openly so you can trust the quality and authenticity 
                  of every beverage at Sky Bar.
                </p>
                <Link to="/receipts" className="sb-btn sb-btn-2 sb-btn-gray">
                  <span className="sb-icon">
                    <img src="img/ui/icons/arrow-2.svg" alt="icon" />
                  </span>
                  <span>View Receipts</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CredibilitySection
